export function formatUpdated(value?: string | null) {
  if (!value) return "—"
  const dt = new Date(value)
  if (Number.isNaN(dt.getTime())) return value
  return dt.toLocaleString(undefined, { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" })
}

export function filterRows<T extends Record<string, unknown>>(rows: T[], search: string, keys: (keyof T)[]) {
  const q = search.trim().toLowerCase()
  if (!q) return rows
  return rows.filter((row) =>
    keys
      .map((key) => String(row[key] ?? ""))
      .join(" ")
      .toLowerCase()
      .includes(q),
  )
}

export async function syncFromSmartolt(runSync: (limit?: number) => Promise<unknown>) {
  await runSync(25)
}
